import { DataCollectionTemplateId, TaskStatus, WarehouseUploadType } from '@core/enums';
import { Badge } from '@shared/badge';

export interface EmissionDashboardTotals {
  total: number;
  transport: number;
  warehouse: number;
}

export interface EmissionDashboardMethods {
  air: number;
  sea: number;
  surface: number;
}

export interface ReportedWarehouses {
  reported: number;
  partiallyReported: number;
  notReported: number;
}

export interface TasksTotals {
  assigned: number;
  notReported: number;
  failures: number;
}

export interface TaskRecord {
  warehouseId: string;
  warehouseName: string;
  reportingMonth: Date;
  template: string;
  templateId?: DataCollectionTemplateId;
  type: WarehouseUploadType;
  status: TaskStatus;
  reportingContacts: string[];
  filename: string | null;
  error: string[] | null;
  uploadedOn: Date | null;
  statusBadge: Badge<TaskStatus>;
}

export interface TasksResponse {
  totals: TasksTotals;
  records: TaskRecord[];
}

// Supply Network
export interface CriticalOrderResponse {
  paused: CriticalOrderStatus;
  cancelled: CriticalOrderStatus;
  delayed: CriticalOrderStatus;
}

export interface CriticalOrderStatus {
  total: number;
  orders: CriticalOrder[];
}

export interface CriticalOrder {
  id: string;
  senderRef: string;
  pausedAt: Date | null;
  cancelledAt: Date | null;
  soonestPromisedDate: Date | null;
  products: CriticalOrderProduct[];
}

export interface CriticalOrderProduct {
  description: string;
  promisedDate: Date;
}

export type CriticalOrderKind = 'paused' | 'cancelled' | 'risk';

export interface CriticalOrderRow {
  id: string;
  poNumber: string;
  date: Date | null;
  products: CriticalOrderProduct[];
}

export interface NetworkHealthResponse {
  trend: number;
  suppliers: {
    name: string;
    otif: {
      value: number;
      trend: number;
    };
    leadTime: {
      value: number;
      trend: number;
    };
    confirmationTime: {
      value: number;
      trend: number;
    };
    ordersIncomplete: {
      otif: number;
      leadTime: number;
      confirmationTime: number;
    };
    ordersTotal: number;
  }[];
}

export interface SuppliersArr {
  name: string;
  otif: {
    value: number;
    trend: number;
  };
  leadTime: {
    value: number;
    trend: number;
  };
  confirmationTime: {
    value: number;
    trend: number;
  };
  ordersIncomplete: {
    otif: number;
    leadTime: number;
    confirmationTime: number;
  };
  ordersTotal: number;
}

export interface NewUpdatesResponse {
  ordersCreated: number;
  ordersUpdated: number;
  commentsCreated: number;
}
